import { type Phone, PhoneType } from '@lmc/ts-common'
import {
  Add,
  Button,
  Chevron,
  FormCard,
  FormItem,
  Input,
  Select,
  Trash,
  theme
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Form as AntdForm } from 'antd'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import useRequiredRule from 'screens/Residents/screens/ResidentImportantPeopleScreens/forms/utils/useRequiredRule'
import { DeleteButtonText } from '../../../styledComponents'
import { getPhoneLabelFromValue } from '../../../utils/utils'
import { gbPhoneValidator } from '../../../utils/validators'

type PhonesFormCardProps = {
  value: Phone[] | undefined
}

export const PhonesFormCard = ({ value }: PhonesFormCardProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const requiredRule = useRequiredRule()

  const phoneTypeOptions = Object.values(PhoneType).map((phoneType) => ({
    label: <Text>{getPhoneLabelFromValue(phoneType)}</Text>,
    value: phoneType
  }))

  return (
    <AntdForm.List name="phones">
      {(fields, { add, remove }) => (
        <FormCard
          title={t(supConstants.PHONE_NO)}
          rightChildren={
            <Button
              type="button"
              variant="text"
              icon={<Add />}
              onClick={() => add()}
            >
              {t(supConstants.ADD_PHONE_NO)}
            </Button>
          }
        >
          {fields.map((field, index) => (
            <FormCard
              key={field.name}
              level={2}
              title={getPhoneLabelFromValue(value?.[index]?.type)}
              rightChildren={
                <Button
                  type="button"
                  variant="text"
                  icon={<Trash color={theme.color.neutral.color4} />}
                  onClick={() => remove(field.name)}
                >
                  <DeleteButtonText>
                    {t(supConstants.DELETE_PHONE_NO)}
                  </DeleteButtonText>
                </Button>
              }
            >
              <FormItem
                name={[field.name, 'type']}
                key={['phones', field.key, 'type'].join('-')}
                label={<Text>{t(supConstants.PHONE_NO_TYPE)}</Text>}
                rules={[requiredRule(t(supConstants.PHONE_NO_TYPE))]}
              >
                <Select
                  suffixIcon={
                    <Chevron
                      direction="down"
                      color={theme.color.neutral.color5}
                    />
                  }
                  options={phoneTypeOptions}
                />
              </FormItem>
              <FormItem
                name={[field.name, 'number']}
                key={['phones', field.key, 'number'].join('-')}
                label={<Text>{t(supConstants.PHONE_NO)}</Text>}
                rules={[{ validator: gbPhoneValidator }]}
              >
                <Input />
              </FormItem>
            </FormCard>
          ))}
        </FormCard>
      )}
    </AntdForm.List>
  )
}
